module.exports = __webpack_public_path__ + "static/Justworks-fdb648abf53da45c4e548fd8751d7bfa.jpg";